import { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import { Info, XCircle } from '@phosphor-icons/react'
import { Trans, useTranslation } from 'react-i18next'

import TextField from '../../../FormLegacy/FormFieldsV2/TextField'

const ApartmentsIdField = ({
  selectedBuilding,
  updateBuildingApartmentsId,
  displaySnackbar,
  handleChange,
  values,
  setFieldTouched,
}) => {
  const { t } = useTranslation(['organisation'])
  const [apartmentIdUpdateError, setApartmentIdUpdateError] = useState('')

  const handleApartmentsIdUpdate = (e) => {
    e.preventDefault()
    setApartmentIdUpdateError('')
    updateBuildingApartmentsId(selectedBuilding.id, values.apartmentsId)
      .then(() => {
        displaySnackbar(t('organisation:places.apartmentsId.toasts.updated'))
      })
      .catch((res) => {
        setApartmentIdUpdateError(res.response?.data?.message)
      })
  }

  return (
    <div className="ctp-apartments-id-field">
      <div className="ctp-apartments-id-field__input-container">
        <TextField
          name={'apartmentsId'}
          label={
            <div className="tooltip-label">
              {t('organisation:places.apartmentsId.label')}{' '}
              <Info size={20} data-tip data-for="apartments-id-tooltip" />
              <ReactTooltip
                className="tooltip"
                id="apartments-id-tooltip"
                multiline
                place="right"
                effect="solid"
              >
                <div style={{ maxWidth: '300px' }}>
                  <Trans
                    i18nKey="organisation:places.apartmentsId.tooltip"
                    components={[<br key="br" />, <b key="b" />]}
                  />
                </div>
              </ReactTooltip>
            </div>
          }
          placeholder={t('organisation:places.apartmentsId.placeholder')}
          onChange={handleChange}
          value={values.apartmentsId}
          onBlur={() => setFieldTouched('apartmentsId')}
        />
        <button
          className="button button-primary auto-width"
          onClick={handleApartmentsIdUpdate}
          disabled={!values.apartmentsId}
        >
          {t('organisation:shared.actions.add')}
        </button>
      </div>
      {apartmentIdUpdateError && (
        <div className="error-message">
          <XCircle size={18} />
          <Trans
            i18nKey="organisation:places.apartmentsId.notFoundError"
            components={[<br key="br" />]}
          />
        </div>
      )}
      {selectedBuilding.apartmentsName && (
        <div className="apartments-name">{selectedBuilding.apartmentsName}</div>
      )}
    </div>
  )
}

export default ApartmentsIdField
